export default __webpack_public_path__ + "static/media/arrow_up_disabled.735b5aa0.svg";